import React from "react";

import "./styles.scss";

interface IFieldProps {
  type?: string;
  value?: any;
  defaultValue?: any;
  disabled?: boolean;
  isError?: boolean;
  placeholder: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  labelText?: string;
  className?: string;
  minLength?: number;
}

const Field: React.FC<IFieldProps> = props => {
  const disableStyle = props.disabled ? "form-row__input_disable" : "";
  const errorStyle = props.isError ? "form-row__input_error" : "";

  return (
    <div className={`form-row ${props.className}`}>
      {props.labelText && (
        <label className={`form-row__label`} htmlFor={props.name}>
          {props.labelText}
        </label>
      )}
      <input
        className={`form-row__input ${disableStyle} ${errorStyle}`}
        type={!props.type ? "text" : props.type}
        value={props.value && props.value}
        defaultValue={props.defaultValue && props.defaultValue}
        placeholder={props.placeholder}
        name={props.name}
        onChange={props.onChange}
        minLength={props.minLength && props.minLength}
      />
    </div>
  );
};

export default Field;
